import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { FormGroup } from '../Form'

export class RadioSelect extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = { current: this.props.defaultValue }
  }

  render() {
    return (
      <FormGroup
        fieldName={this.props.fieldName}
        fieldCaption={this.props.fieldCaption}
      >
        {this.props.values.map(val => (
          <label key={val.key} className={midas.formRadio}>
            <input
              type="radio"
              name={this.props.fieldName}
              onClick={e => this.setState({ current: e.target.name })}
            />
            <i className={midas.formIcon} /> {val.value}
          </label>
        ))}
      </FormGroup>
    )
  }
}

RadioSelect.defaultProps = {
  defaultValue: null,
}

RadioSelect.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  defaultValue: PropTypes.string,
}
